module.exports = __webpack_public_path__ + "assets/img/jbm3.0ccea65f.jpg";